import React,{useRef,useState,useEffect} from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import DefaultAva from 'assets/icon/default-ava.jpeg'

import Close from 'assets/icon/close-white.png'
import ImageUpload from 'assets/icon/imageUpload.png'
import VideoUpload from 'assets/icon/VideoUpload.png'
import DocumentUpload from 'assets/icon/DocumentUpload.png'
import { handleFile } from 'components/handleFile'
import FileGambar from './FileGambar';
import FileLink from './FileLink';
import FilePdf from './FilePdf';
import FileVideo from './FileVideo';
import CommentOnCardItem from './CommentOnCardItem'
import { modalToggle } from '../../redux/actions/general'
import { useDispatch,useSelector } from 'react-redux'
import { getForumDetailBySlug,deleteDiskusi,postForumAction ,postDiskusi} from 'redux/actions/forum'
import LoadingComment from 'components/LoadingComment'
import { setReducer } from 'redux/actions/reducer'
import { CircularProgress } from '@material-ui/core'
import { setLoadingComment } from '../../redux/actions/general'
import Tooltip from '@material-ui/core/Tooltip';
import Cookie from 'universal-cookie'

import { withStyles, makeStyles } from '@material-ui/core/styles';
const cookie=new Cookie()
const profile=cookie.get('profile_cookie_forum')
const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      padding:8,
      backgroundColor: 'black',
      color: 'white',
      fontSize: theme.typography.pxToRem(12),
      border: 'black',
      boxShadow: 'black',
    },
    arrow: {
        "&:before": {
          border: '1px solid black',
          backgroundColor: "black",
        },
      },
  }))(Tooltip);
export default function CommentOnCard({data}) {
    const inputFile = useRef(null) 
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    const reducer = useSelector(state => state.reducer)
    const persist = useSelector(state => state.persist)
    const [state, setstate] = useState({
        Id:0,
        ForumId:0,
        ParentId:0,
        Title:'',
        Text:'',
        Tags:[],
        Files:null,
        File_url:'',
        extension:''
    })
    // console.log(`from comment`, data)
    const [option, setoption] = useState({})
    const [option_comment, setoption_comment] = useState({})
    const {beranda,forum_detail}=reducer
    const {forum_sort,forum_auth}=persist

    useEffect(() => {
        if(forum_detail!==null){
            setstate({
                ...state,
                ParentId:forum_detail.id,
                Text:'',
                Files:null,
                File_url:'',
                extension:''
            })
        }
    }, [forum_detail])
    const getAsyncDetail=async ()=>{
        let res=await dispatch(getForumDetailBySlug(`/${1}/${1}/${50}/${data.slug}`))
        if(res){
            setstate({
                ...state,
                ParentId:res.id,
                Text:'',
                Files:null,
                File_url:'',
                extension:''
            })
        }
    }
    const uploadImage=()=>{
        inputFile.current.click();
    }
    const uploadVideo=()=>{
        inputFile.current.click();
    }
    const uploadFile=()=>{
        inputFile.current.click();
    }
    const handleFiles=(e,type)=>{
        let handle= handleFile(e)
        if(handle.file_error===null){
            let file_url=URL.createObjectURL(handle.file)
            setstate({...state,Files:handle.file,File_url:file_url,extension:handle.extension})

        }
    }
    const renderPreviewFile=()=>{
        let {extension}=state
        if(extension==='jpg'||extension==='jpeg'||extension==='png'){
            return <FileGambar url={state.File_url}/>
        }
        if(extension==='pdf'){
            return <FilePdf url={state.File_url} preview={true}/>
        }
        if(extension==='mp4'){
            return <FileVideo url={state.File_url}/>
        }
        if(extension==='link'){
            return <FileLink url={state.File_url}/>
        }
    }
    
    function linkify(text) {
        var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
        return text.match(urlRegex)
    }
    function get_url_extension( url ) {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }
    const onChangeDesc=(e)=>{
        let {value}=e.target
        if(linkify(value)!==null){
            setstate({...state,Text:value,File_url:linkify(value)[0],extension:'link'})
        }else{
            setstate({...state,Text:value})
        }
    }
    const optionToggle=(data,i)=>{
        setoption({...option,[i]:!option[i]})
    }
    const onClickVote=(data,i)=>{
        if(forum_auth.canVote){
            if(data.level===0){
                forum_detail.nvote=forum_detail.isVoted===false?forum_detail.nvote+1:forum_detail.nvote
                forum_detail.isVoted=true
                dispatch(setReducer({forum_detail:forum_detail}))
                dispatch(postForumAction(`/vote/${data.id}`))
            }
            if(data.level===1){
                forum_detail.child[i].nvote=forum_detail.child[i].isVoted===false?forum_detail.child[i].nvote+1:forum_detail.child[i].isVoted
                forum_detail.child[i].isVoted=true
                dispatch(setReducer({forum_detail:forum_detail}))
                dispatch(postForumAction(`/vote/${data.id}`))
            }
            
        }
        
    }
    const flagAction=(data,i,i2,i3)=>{
        if(data.level===0){
            forum_detail.nflag=forum_detail.nflag+1
            forum_detail.isFlag=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/flag/${data.id}`))
        }
        if(data.level===1){
            forum_detail.child[i].nflag=forum_detail.child[i].nflag+1
            forum_detail.child[i].isFlag=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/flag/${data.id}`))
        }

        if(data.level===2){
            forum_detail.child[i].child[i2].nflag=forum_detail.child[i].child[i2].nflag+1
            forum_detail.child[i].child[i2].isFlag=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/flag/${data.id}`))
        }
        if(data.level===3){
            forum_detail.child[i].child[i2].child[i3].nflag=forum_detail.child[i].child[i2].child[i3].nflag+1
            forum_detail.child[i].child[i2].child[i3].isFlag=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/flag/${data.id}`))
        }
        return data
    }
    const onClickFlag=(data,i,i2,i3)=>{
        if(forum_auth.canFlag){
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "",
                modal_component: "delete_diskusi",
                modal_size:400,
                modal_type:'delete',
                modal_data:{
                    actionDelete:()=>flagAction(data,i,i2,i3),
                    getAction:()=>null,
                    data,
                    title:' Laporkan Postingan Ini',
                    desc:'Postingan ini mengandung unsur yang tidak relevan dengan forum diskusi, laporkan postingan ini untuk ditinjau oleh tim kami dan akan dihapus jika memang merupakan postingan yang tidak relevan.',
                    btn_delete:'Laporkan'
                },
                modal_action:'delete_diskusi',
            }))
            
        }
    }
    const onClickMark=(data,i,i2,i3)=>{
        if(data.level===1){
            forum_detail.child[i].nMark=forum_detail.child[i].nMark+1
            forum_detail.child[i].isMark=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/mark/${data.id}`))
        }

        if(data.level===2){
            forum_detail.child[i].child[i2].nMark=forum_detail.child[i].child[i2].nMark+1
            forum_detail.child[i].child[i2].isMark=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/mark/${data.id}`))
        }
        if(data.level===3){
            forum_detail.child[i].child[i2].child[i3].nMark=forum_detail.child[i].child[i2].child[i3].nMark+1
            forum_detail.child[i].child[i2].child[i3].isMark=true
            dispatch(setReducer({forum_detail:forum_detail}))
            dispatch(postForumAction(`/mark/${data.id}`))
        }
    }
    const replyComment=(data)=>{
        if(forum_auth.canComment){
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "Balas Komentar",
                modal_component: "reply_comment",
                modal_size:590,
                modal_type:'',
                modal_data:{
                    getAction:()=>getAsyncDetail(),
                    ParentId:data.id
                },
                modal_action:'reply_comment',
            }))
        }
        
    }
    const optionCommentToggle=(data,i)=>{
        setoption_comment({...option_comment,[i]:!option_comment[i]})
    }
    const editComment=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Edit Komentar",
            modal_component: "add_comment",
            modal_size:590,
            modal_type:'',
            modal_data:{
                getAction:()=>getAsyncDetail(),
                ParentId:forum_detail.id,
                data
            },
            modal_action:'edit_comment',
        }))
    }
    const deleteComment=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "",
            modal_component: "delete_diskusi",
            modal_size:400,
            modal_type:'delete',
            modal_data:{
                actionDelete:()=>dispatch(deleteDiskusi(data.id)),
                getAction:()=>getAsyncDetail(),
                data,
                title:' Hapus Komentar Kamu',
                desc:'Komentar yang kamu pilih akan dihapus',
                btn_delete:'Hapus Komentar'
            },
            modal_action:'delete_comment',
        }))
    }
    const onCreate=async ()=>{
        let fd= new FormData()
        fd.append('Id',state.Id)
        fd.append('ForumId',persist.forum_id)
        fd.append('ParentId',state.ParentId)
        fd.append('Title',state.Title)
        fd.append('Text',state.Text)
        fd.append('Files',state.Files)
        let res=await dispatch(postDiskusi(fd))
        if(res){
            getAsyncDetail()
        }
    }
    // console.log('from card',forum_detail)

    return (
        <div>
            <div className='card-comment'>
                <div className='div-flex' style={{width:'100%'}}>
                    <img src={profile.profilePic!==''?profile.profilePic:DefaultAva} className='ava-circle'/>
                    &nbsp;&nbsp;
                    <div className='card-comment-wrapper'>
                        <div className='comment-textarea'>
                            <TextareaAutosize value={state.Text} onChange={onChangeDesc}  className='font-nunito comment-field' placeholder="Tulis Komentar"></TextareaAutosize>
                            {state.File_url!==''&&
                            <div style={{position:'relative'}}>
                                {renderPreviewFile()}
                                <div className='cancel-btn'>
                                    <img src={Close} style={{height:20}}  onClick={()=>setstate({...state,Files:null,File_url:''})}/>
                                </div>
                            </div>}
                        </div>
                        <div className='div-flex div-justify-between'>
                            <button onClick={onCreate} className='btn-forum'>
                                {general.isLoading?
                                    <CircularProgress style={{color:'white'}}  size={20} />
                                    :"Tambahkan"
                                }
                            </button>
                            <div className='file-diskusi div-flex'>
                                <HtmlTooltip title="Upload Gambar" placement="bottom" arrow>
                                <div  onClick={uploadImage}>
                                    <input  onChange={(e)=>handleFiles(e,'image')}  type='file' id='file' ref={inputFile} style={{display: 'none'}}/>
                                    <img src={ImageUpload}/>
                                </div>
                                </HtmlTooltip>
                                <HtmlTooltip title="Upload Video" placement="bottom" arrow>
                                <div onClick={uploadVideo}>
                                    <input onChange={(e)=>handleFiles(e,'video')} type='file' id='file' ref={inputFile} style={{display: 'none'}}/>
                                    <img src={VideoUpload}/>
                                </div>
                                </HtmlTooltip>
                                <HtmlTooltip title="Upload File" placement="bottom" arrow>
                                <div onClick={uploadFile}>
                                    <input onChange={(e)=>handleFiles(e,'doc')} type='file' id='file' ref={inputFile} style={{display: 'none'}}/>
                                    <img src={DocumentUpload}/>
                                </div>
                                </HtmlTooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            {general.isLoadingComment?
                <LoadingComment/>
            :
            forum_detail!==null&&forum_detail.child.map((data,i)=>(
                <CommentOnCardItem 
                    data={data}
                    onClickVote={onClickVote}
                    onClickFlag={onClickFlag}
                    index={i}
                    replyComment={replyComment}
                    onClickMark={onClickMark}
                    forum_auth={forum_auth}
                    key={i}
                    option_comment={option_comment}
                    optionCommentToggle={optionCommentToggle}
                    editComment={editComment}
                    deleteComment={deleteComment}
                />
            ))}
            
        </div>
    )
}
